import { gql } from "@apollo/client";

export default gql`
  query analyzeAiMessageRun($data: AnalyzeAiMessageRunInput!){
    analyzeAiMessageRun(data: $data){
        success
        data
        code
        message
    }
}
`
